import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {Area} from 'recharts';

const StyledActionArea = styled(Area)`
  &.ActionLine-clickable {
    cursor: pointer;
  }
  
  .AreaChartDot-clickable {
    cursor: pointer;
  }
  
  ${ComponentStyles}
`;

StyledActionArea.propTypes = {
  theme: PropTypes.object
};

export default StyledActionArea;
